var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Cancel component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconCancel extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.90834 4.84768C7.54864 3.44917 9.67597 2.60498 12.0005 2.60498C17.1893 2.60498 21.3955 6.81126 21.3955 12C21.3955 14.3245 20.5513 16.4519 19.1528 18.0921L5.90834 4.84768ZM4.37842 4.21503C4.34767 4.23754 4.31825 4.26269 4.29047 4.29047C4.26268 4.31827 4.23752 4.3477 4.215 4.37846C2.29136 6.34322 1.10547 9.03311 1.10547 12C1.10547 18.0172 5.98333 22.895 12.0005 22.895C14.9667 22.895 17.6561 21.7096 19.6207 19.7868C19.652 19.764 19.6819 19.7385 19.7102 19.7102C19.7384 19.682 19.7639 19.652 19.7867 19.6207C21.7099 17.6561 22.8955 14.9665 22.8955 12C22.8955 5.98284 18.0177 1.10498 12.0005 1.10498C9.03333 1.10498 6.34322 2.29109 4.37842 4.21503ZM18.0921 19.1528C16.4519 20.551 14.3247 21.395 12.0005 21.395C6.81175 21.395 2.60547 17.1888 2.60547 12C2.60547 9.67573 3.44947 7.54861 4.84772 5.90838L18.0921 19.1528Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconCancel.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconCancel.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconCancel.prototype, "size", void 0);
if (customElements.get('cat-icon-cancel') === undefined) {
    customElements.define('cat-icon-cancel', BlocksIconCancel);
}
